<script lang="ts">
	import { onMount } from 'svelte';

	export interface TocItem {
		id: string;
		text: string;
		level: number;
	}

	interface Props {
		headings: TocItem[];
	}

	let { headings }: Props = $props();
	let activeId = $state<string | null>(null);

	onMount(() => {
		if (headings.length === 0) return;

		const observer = new IntersectionObserver(
			(entries) => {
				for (const entry of entries) {
					if (entry.isIntersecting) {
						activeId = entry.target.id;
					}
				}
			},
			{ rootMargin: '-100px 0px -80% 0px' }
		);

		for (const heading of headings) {
			const el = document.getElementById(heading.id);
			if (el) observer.observe(el);
		}

		return () => observer.disconnect();
	});
</script>

{#if headings.length > 0}
	<nav class="sticky top-24">
		<h4 class="font-mono text-[11px] uppercase tracking-wider text-[#878787] mb-4">
			On this page
		</h4>
		<ul class="space-y-2 border-l border-[#e5e5e5]">
			{#each headings as heading}
				<li style="padding-left: {8 + (heading.level - 2) * 12}px">
					<a
						href="#{heading.id}"
						class="block text-[14px] text-[#5c5855] hover:text-[#ee6018] transition-colors py-1 -ml-px border-l-2 pl-3"
						class:border-[#ee6018]={activeId === heading.id}
						class:text-[#ee6018]={activeId === heading.id}
						class:font-medium={activeId === heading.id}
						class:border-transparent={activeId !== heading.id}
					>
						{heading.text}
					</a>
				</li>
			{/each}
		</ul>
	</nav>
{/if}
